import { createSlice } from "@reduxjs/toolkit";

export const SearchKeys = createSlice({
  name: "searchKeys",
  initialState: {
    searchKeys: {
      educationByName: "",
      companyByName: "",
      supplierByName: "",
      workerByName: "",
      workerByCompanyId: "All",
      userByName: "",
      creatorByName: "",
      categoryName: "",
      subCategoryName: "",
      mainCategoryId: "All",
      subCategoryId: "All",
      serviceName: "",
      subServiceName: "",
      ecomCategoryId: "All",
      ecomSubCategoryId: "All",
      ecomSubSubCategoryId: "All",
      ecommerceTagName: "",
      productName: "",
      vendorId: "all",
      ecomCategoryIdForPackage: "All",
      packageByName: "",
      vendorsForPackage: "all",
      subscriptionHistoryRole: "worker",
      subscriptionHistoryUserId: "All",
      ecommerceOrderId: "",
      notificationTitle: "",
      productNameReview: "",
      vendorIdForReview: "all",
      reviewProductType: "All",
      appointmentByCompany: "All",
      appointmentByWorker: "All",
      appointmentByWorkerStatus: "All",
      appointmentByStatus: "All",
      notificationRelatedTo: "All",
      userPackageName: "",
      bannerName: "",
      ecommerceTagAppliesTo: "",
      ecommerceTagSolutionType: "",
      attributeName: "",
      discountRuleName: "",
      usersPlanName: "",
      usersPlanStartDate: null,
      usersPlanEndDate: null,
      inventoryMovementName: "",
      inventoryMovementType: "All",
      inventoryMovementVendorId: "all",
      inventoryMovementStartDate: null,
      inventoryMovementEndDate: null,

      // Promotional Block
      promotionalBlockName: "",
      promotionalBlockStartDate: null,
      promotionalBlockEndDate: null,

      // Blog Subscribers
      blogSubscriberEmail: "",

      // Charity Organizations
      charityOrganizationName: "",

      // Donations
      donationOrganization: "",
      donationStartDate: null,
      donationEndDate: null,

      // Brands
      brand: "",

      // Gift Card
      giftCard: "",

      // Blog Topic
      blogTopic: "",

      // Event Category
      eventCategory: "",

      //Promo Code
      promoCode:"" 
    },
  },
  reducers: {
    setSearchKeys: (state, action) => {
      state.searchKeys = action.payload;
    },
    setNotificationRelatedTo: (state, action) => {
      state.searchKeys.notificationRelatedTo = action.payload;
    },
    setEcommerceTagAppliesTo: (state, action) => {
      state.searchKeys.ecommerceTagAppliesTo = action.payload;
    },
    setEcommerceTagSolutionType: (state, action) => {
      state.searchKeys.ecommerceTagSolutionType = action.payload;
    },
    setAttributeName: (state, action) => {
      state.searchKeys.attributeName = action.payload;
    },
    setDiscountRuleName: (state, action) => {
      state.searchKeys.discountRuleName = action.payload;
    },
    setUsersPlanName: (state, action) => {
      state.searchKeys.usersPlanName = action.payload;
    },
    setUsersPlanStartDate: (state, action) => {
      state.searchKeys.usersPlanStartDate = action.payload;
    },
    setUsersPlanEndDate: (state, action) => {
      state.searchKeys.usersPlanEndDate = action.payload;
    },
    setInventoryMovementName: (state, action) => {
      state.searchKeys.inventoryMovementName = action.payload;
    },
    setInventoryMovementType: (state, action) => {
      state.searchKeys.inventoryMovementType = action.payload;
    },
    setInventoryMovementVendorId: (state, action) => {
      state.searchKeys.inventoryMovementVendorId = action.payload;
    },
    setInventoryMovementStartDate: (state, action) => {
      state.searchKeys.inventoryMovementStartDate = action.payload;
    },
    setInventoryMovementEndDate: (state, action) => {
      state.searchKeys.inventoryMovementEndDate = action.payload;
    },
    // Promotional Block
    setPromotionalBlockName: (state, action) => {
      state.searchKeys.promotionalBlockName = action.payload;
    },
    setPromotionalBlockStartDate: (state, action) => {
      state.searchKeys.promotionalBlockStartDate = action.payload;
    },
    setPromotionalBlockEndDate: (state, action) => {
      state.searchKeys.promotionalBlockEndDate = action.payload;
    },
    // Blog Subscribers
    setBlogSubscriberEmail: (state, action) => {
      state.searchKeys.blogSubscriberEmail = action.payload;
    },
    setCharityOrganizationName: (state, action) => {
      state.searchKeys.charityOrganizationName = action.payload;
    },
    setDonationUser: (state, action) => {
      state.searchKeys.donationUser = action.payload;
    },
    setDonationOrganization: (state, action) => {
      state.searchKeys.donationOrganization = action.payload;
    },
    setDonationStartDate: (state, action) => {
      state.searchKeys.donationStartDate = action.payload;
    },
    setDonationEndDate: (state, action) => {
      state.searchKeys.donationEndDate = action.payload;
    },
    setBrand: (state, action) => {
      state.searchKeys.brand = action.payload;
    },
    setGiftCard: (state, action) => {
      state.searchKeys.giftCard = action.payload;
    },
    setBlogTopic: (state, action) => {
      state.searchKeys.blogTopic = action.payload;
    },
    setEventCategory: (state, action) => {
      state.searchKeys.eventCategory = action.payload;
    },
    setPromoCode: (state, action) => {
      state.searchKeys.promoCode = action.payload;
    },
  },
});

export const {
  setSearchKeys,
  setNotificationRelatedTo,
  setEcommerceTagAppliesTo,
  setEcommerceTagSolutionType,
  setDiscountRuleName,
  setUsersPlanName,
  setUsersPlanStartDate,
  setUsersPlanEndDate,
  setInventoryMovementName,
  setInventoryMovementType,
  setInventoryMovementVendorId,
  setInventoryMovementStartDate,
  setInventoryMovementEndDate,
  setPromotionalBlockName,
  setPromotionalBlockStartDate,
  setPromotionalBlockEndDate,
  setBlogSubscriberEmail,
  setCharityOrganizationName,
  setDonationUser,
  setDonationOrganization,
  setDonationStartDate,
  setDonationEndDate,
  setBrand,
  setGiftCard,
  setBlogTopic,
  setEventCategory,
  setPromoCode
} = SearchKeys.actions;

export default SearchKeys.reducer;
